<template>
    <div class="reservation reservationNavigationBar">
        <div class="buttons">
            <div class="wrapper">
                <a v-if="shop.contact_url && shop.contact_flag === 1" :href="shop.contact_url" target="_blank" rel="noopener" class="button outlined">問い合わせ</a>
                <contact v-else-if="shop.contact_flag === 1" :shop="shop"></contact>
                <a v-if="shop.reservation_url && shop.reservation_flag === 1" :href="shop.reservation_url" target="_blank" rel="noopener" class="button">予約する</a>
                <reservation v-else-if="shop.reservation_flag === 1" :shop="shop" :coupons="coupons"></reservation>
            </div>
        </div>
    </div>
</template>
<script>
import Reservation from './Reservation.vue';
import Contact from './Contact.vue';

export default {
    components: {
        'reservation': Reservation,
        'contact': Contact
    },
    props: {
        shop: Object,
        coupons: Array
    },
    data () {
        return {

        }
    }
}
</script>

<style lang="scss">
#app.is-app {
  .reservationNavigationBar {
    margin-bottom: 0;
  }
}

.reservationNavigationBar {
  border-top: #ededed 1px solid;

  @media screen and (max-width: 768px) {
    margin-bottom: 6.4rem;
  }
}
</style>
